export default __webpack_public_path__ + "static/media/iPhone_Mockup.a2818b88.png";